import React, { useEffect, useState } from "react";
import { RecIcon } from "../materials/MaterialRecordParts";
import { usePermissions } from "../../hooks/usePermissions";
import {
  loadTimeLogTaskProgress,
  TIME_LOG_TASKS_FAILED,
  TIME_LOG_TASKS_OFFLINE,
} from "../../helpers/tasks/taskProgress";
import "../tasks/tasks.css";

/**
 * Read-only "Tasks" for one Time Log: the task progress reported in this
 * session, exactly as recorded at the time (previous → reported). Nothing is
 * editable here and nothing is inferred. Omitted when nothing was reported.
 */
export function TimeLogTasksSection({ log }) {
  const { actor } = usePermissions();
  const [state, setState] = useState({ status: "loading", rows: [] });
  const logId = log?.id;
  const orgId = log?.organization_id;

  useEffect(() => {
    let alive = true;
    setState({ status: "loading", rows: [] });
    loadTimeLogTaskProgress(actor, { id: logId, organization_id: orgId }).then((result) => {
      if (alive) setState(result);
    });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logId, orgId]);

  const { status, rows } = state;
  if (status === "loading" || status === "none") return null;
  if (status === "ready" && rows.length === 0) return null;

  return (
    <section className="rec-card tl-tasks" aria-label="Tasks" data-testid="time-log-tasks">
      <div className="rec-label">
        <RecIcon name="check" />
        Tasks
      </div>
      {status === "offline" ? <p className="tl-tasks__note">{TIME_LOG_TASKS_OFFLINE}</p> : null}
      {status === "failed" ? <p className="tl-tasks__note">{TIME_LOG_TASKS_FAILED}</p> : null}
      {rows.length ? (
        <ul className="tl-tasks__list">
          {rows.map((row) => (
            <li key={row.id} className="tl-tasks__row" data-testid="time-log-task-row">
              <span className={`tl-tasks__title${row.completed ? " is-done" : ""}`}>
                {row.title}
                {row.archived ? <small className="tl-tasks__tag">Archived</small> : null}
              </span>
              <span
                className={`tk-chip ${row.completed ? "tk-chip--status is-done" : "tk-chip--progress"}`}
                data-testid="time-log-task-change"
              >
                {row.completed ? <RecIcon name="check" /> : null}
                {row.text}
              </span>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
